<template>
  <div />
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useActivationStore, useSessionStore } from 'src/store';
import { handleApiRequest } from 'src/api/handleApiRequest';
import { postLogin, postMagicLinkLogin } from 'src/api/endpoints/loginWeb';
import { useQuasar } from 'quasar';
import { getUserSession } from 'src/api/endpoints/userWeb';
import { AuthPolicyEnum } from 'src/constants/authPolicyEnum';

const router = useRouter();
const sessionModule = useSessionStore();
const activationStore = useActivationStore()
const $q = useQuasar()


onMounted(async () => {
  $q.loading.show()
  const model = {
    username: activationStore.registrationUsername,
    password: activationStore.registrationPassword,
    utcOffset: sessionModule.utcOffset,
    countryCode: activationStore.activateStart.countryCode,
    magicLinkToken: activationStore.registrationMagicLink,
    lastName: activationStore.registrationLastName,
    dateOfBirth: activationStore.registrationDateOfBirth
  };

  if(model.countryCode == null || model.countryCode.length == 0){
    model.countryCode = activationStore.supportedCountries.selectedCountryCode;
  }

  if (model.username && model.password || (model.magicLinkToken && model.lastName && model.dateOfBirth)) {
    if (model.username) {
      model.dateOfBirth = null;
      await handleApiRequest(() => postLogin(model), null, $q).finally(() => $q.loading.hide);
    }
    else {
      await handleApiRequest(() => postMagicLinkLogin(model), null, $q).finally(() => $q.loading.hide);
    }
    activationStore.setResetState();

    const userSession = await getUserSession();
    const isUnregisteredPatient = userSession?.user?.policies?.some(p => p.includes(AuthPolicyEnum.UnregisteredPatientWith2FA))
                                      || userSession?.user?.policies?.some(p => p.includes(AuthPolicyEnum.UnregisteredPatientWithout2FA));
    // If user is still not registered for any reason
    if (isUnregisteredPatient) {
      router.replace({ name: 'Welcome' });
    } 
    router.push({ name: 'Authenticate', query:{skipStep: "LoginWithExisting"}});
  } else {
    $q.loading.hide
    router.replace({ name: 'Welcome' });
  }
});
</script>